import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { citiesByProvince } from "../data/cities";
import { FR_SLUGS, frCityName, frLabels } from "../data/frContent";
import { getHead } from "../seo/routes";
import { Seo } from "../components/Seo";
import { PageHero, CTABand } from "../components/Blocks";

const head = getHead("/fr/villes");

export default function FrVilles() {
  const qcCities = citiesByProvince("quebec");
  return (
    <>
      <Seo title={head.title} description={head.description} path="/fr/villes" lang="fr-CA" alternates={head.alternates} />
      <PageHero
        overline="Régions desservies"
        title="Villes du Québec desservies"
        lead="Maze Security Solutions déploie des gardiens licenciés par le Bureau de la sécurité privée dans 99 villes du Québec. Choisissez votre ville pour voir les services offerts, les réponses aux questions fréquentes et les détails de couverture locale."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="fr-cities-directory">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
          {qcCities.map((c) => (
            <Link
              key={c.slug}
              to={`/fr/${FR_SLUGS[c.slug]}`}
              data-testid={`fr-ville-${c.slug}`}
              className="flex items-center gap-1.5 text-sm text-gray-400 hover:text-white transition-colors py-1.5"
            >
              <MapPin className="h-3 w-3 text-[#FF5500] shrink-0" /> {frCityName(c.slug)}
            </Link>
          ))}
        </div>
      </section>
      <CTABand title={frLabels.ctaTitle("votre ville")} sub="Appelez notre répartition 24/7 ou écrivez-nous — la couverture suit la demande, même au-delà des villes listées." />
    </>
  );
}
